import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    _count: 0 as number,
    isLoading: false as boolean,
    _showTimer: null as number | null,
  }),
  actions: {
    start(delay = 120) {
      this._count = Math.max(0, this._count) + 1
      if (this._showTimer == null) {
        this._showTimer = window.setTimeout(() => {
          this.isLoading = this._count > 0
          this._showTimer = null
        }, delay) as unknown as number
      }
    },
    stop() {
      this._count = Math.max(0, this._count - 1)
      if (this._count <= 0) {
        if (this._showTimer != null) {
          clearTimeout(this._showTimer)
          this._showTimer = null
        }
        this.isLoading = false
        this._count = 0
      }
    },
    reset() {
      if (this._showTimer != null) {
        clearTimeout(this._showTimer)
        this._showTimer = null
      }
      this._count = 0
      this.isLoading = false
    },
  },
})
